export enum LinkType {
  RESOURCE = 'RESOURCE',
  DYNAMIC_DATA = 'DYNAMIC_DATA'
}
